import { budgetReportingCategories, type BudgetOpexWorkspace } from '@kop/contracts';
export function budgetReportingSummary(aggregates: BudgetOpexWorkspace['aggregates']) {
  const rows = budgetReportingCategories.map(category => {
    const source = aggregates.categories.find(row => row.name === category.name);
    return { ...category, amount: source?.principal ?? 0, count: source?.principalCount ?? 0 };
  });
  const unmatched = aggregates.categories.filter(row => !budgetReportingCategories.some(category => category.name === row.name));
  return { rows, unclassified: unmatched.reduce((sum, row) => sum + row.principal, 0), unclassifiedCount: unmatched.reduce((sum, row) => sum + (row.principalCount ?? 0), 0), count: aggregates.categories.reduce((sum, row) => sum + (row.principalCount ?? 0), 0) };
}
